import { Typography } from '@iheartjane/reefer';
import type { ProductCategory, ProductKind } from '@iheartjane/types';
import { sentenceCase } from '@iheartjane/utils';
import { clsx } from 'clsx';

import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';
import { formatLabel } from '@jane/bloom/utils/strings/formatLabel';

import styles from './productCategoryLabel.module.css';

export type CategoryProps = {
  category?: ProductCategory | null;
  className?: string;
  kind: ProductKind;
};

export function ProductCategoryLabel({
  category,
  className,
  kind,
}: CategoryProps) {
  const customLanguage = useCustomLanguage();
  const lineageLabel = category
    ? customLanguage.lineageLabels?.[category] || category
    : // this resolves to false and goes to the second case
      '';
  const kindLabel = customLanguage.productTypeLabels?.[kind] || kind;

  return (
    <Typography className={className} variant="mini" maxLines={1}>
      {lineageLabel ? (
        <>
          <span
            className={clsx({
              [styles['cbdLabel']]: category === 'cbd',
              [styles['hybridLabel']]: category === 'hybrid',
              [styles['indicaLabel']]: category === 'indica',
              [styles['sativaLabel']]: category === 'sativa',
            })}
          >
            {formatLabel(lineageLabel, { uppercaseAcronyms: ['CBD'] })}{' '}
            {kindLabel}
          </span>
        </>
      ) : (
        <>{sentenceCase(kindLabel)}</>
      )}
    </Typography>
  );
}
